import React from 'react';
import classNames from 'classnames';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentStoryHit as Type } from '../../../../SearchAllContent/types';
import constructImageSourcesArray from '../../../../../helpers/constructImageSources';
import { epochToDateString } from '../../../../../helpers';

import Card from '../../../../Card';

import './style.scss';

const MetaSearchStoryHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('MetaSearchHit', 'MetaSearchStoryHit');

  return (
    <Card className={classes}>
      <Card.Content>

        <Card.Link href={hit.url[0]}>
          <div className="backdrop" />
          <Card.Image
            image={(
              <Image
                src={constructImageSourcesArray(hit, '1_1')}
                alt={hit.image_alt?.[0]}
                lazyload={false}
              />
            )}
          />

          <div className="MetaSearchStoryHit__text-wrapper">
            <div className="Card__content__body">
              <div className="Card__content__metadata">
                {hit.quote && (
                  <span className="MetaSearchStoryHit__badge">
                    {hit.page_title[0]}
                  </span>
                )}
              </div>


              <Card.Title title={hit.quote ? hit.quote[0] : hit.page_title[0]} />

            </div>
          </div>
        </Card.Link>
      </Card.Content>
    </Card>
  );
};

export default MetaSearchStoryHit;
